import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { HopperIcon } from '../ui/icons/HopperIcon';

export function PulsePhotoLightbox({ src, onClose }: { src: string; onClose: () => void }) {
  const closeRef = useRef<HTMLButtonElement>(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    closeRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { event.preventDefault(); onCloseRef.current(); }
      if (event.key === 'Tab') { event.preventDefault(); closeRef.current?.focus(); }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => { document.removeEventListener('keydown', onKeyDown); previousFocus?.focus(); };
  }, []);

  return createPortal(
    <div className="pulse-photo-lightbox" role="dialog" aria-modal="true" aria-label="Просмотр фотографии"
      onClick={(event) => { event.stopPropagation(); if (event.currentTarget === event.target) onClose(); }}>
      <button ref={closeRef} type="button" className="pulse-photo-lightbox__close" aria-label="Закрыть фотографию" onClick={(event) => { event.stopPropagation(); onClose(); }}>
        <HopperIcon name="close" size={24} />
      </button>
      <img src={src} alt="Фотография в увеличенном размере" onClick={(event) => event.stopPropagation()} />
    </div>,
    document.body,
  );
}
